var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.066,
    height: 6.442,
    viewBox: "0 0 5.066 6.442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#005699;stroke:#005699;stroke-miterlimit:10;stroke-width:0.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.333 -3.442)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.458 3.567)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.941,6.192a.9.9,0,0,1-.876-.929.958.958,0,0,1,.093-.414L1.487,3.759a.844.844,0,0,1-.611.266A.9.9,0,0,1,0,3.1a.9.9,0,0,1,.876-.929.845.845,0,0,1,.609.264L3.156,1.34A.964.964,0,0,1,3.065.929.9.9,0,0,1,3.941,0a.9.9,0,0,1,.876.929.9.9,0,0,1-.876.929.844.844,0,0,1-.611-.266L1.658,2.682a.959.959,0,0,1,.093.414.974.974,0,0,1-.091.411L3.332,4.6a.845.845,0,0,1,.609-.264.93.93,0,0,1,0,1.858Zm0-1.548a.62.62,0,1,0,.584.619A.6.6,0,0,0,3.941,4.644ZM.876,2.477A.6.6,0,0,0,.292,3.1a.6.6,0,0,0,.584.619A.6.6,0,0,0,1.46,3.1.6.6,0,0,0,.876,2.477ZM3.941.31a.6.6,0,0,0-.584.619.585.585,0,1,0,1.168,0A.6.6,0,0,0,3.941.31Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnShare);
export default __webpack_public_path__ + "static/media/BTN_Share.a75181c68af86eb38a87c39c131ceecd.svg";
export { ForwardRef as ReactComponent };